import Button from "@material-ui/core/Button";
import CancelOutlined from "@material-ui/icons/Clear";
import "../styles.css";

function NewContent(props) {
  const { display } = props;
  const hidePopup = () => {
    props.setPopupDisplay("none");
    document.body.style.overflow = "auto";
    return null;
  };
  return (
    <div className="NewUserPopup" style={{ display }}>
      <div
        className="PopupTransparentBg"
        id="PopupTransparentBg"
        onClick={() => hidePopup()}
      ></div>
      <div className="NewUserContent">
        <div className="NewUserHeader">
          <Button onClick={() => hidePopup()} title="Close">
            <CancelOutlined />
          </Button>
        </div>
        <form action="/" method="POST" autoComplete="off">
          <div>
            <input type="text" name="author" placeholder="Author" required />
            <input type="text" name="title" placeholder="Title" required />
          </div>
          <div>
            <input type="email" name="userEmail" placeholder="Email" required />
            <input
              type="text"
              name="subtitle"
              placeholder="Sub Title"
              required
            />
          </div>
          <div>
            <select name="userCategory" required>
              <option value="" disabled selected>
                Content For
              </option>
              <option>Simple</option>
              <option>Micro</option>
              <option>Medium-size</option>
              <option>Macro</option>
              <option>International</option>
            </select>
            <textarea name="description" placeholder="Description"></textarea>
          </div>
          <div>
            <input type="submit" value="Add Content" />
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewContent;
